export const MOONPAY_CLIENT_API_KEY =
  process.env.NEXT_PUBLIC_MOONPAY_CLIENT_API_KEY ||
  "pk_live_IdYWVj39NNgSrt2t9jBPSgwl9outsydU"

export const MOONPAY_NFT_CLIENT_API_KEY =
  process.env.NEXT_PUBLIC_MOONPAY_NFT_CLIENT_API_KEY ||
  "pk_live_fzb75PNGOvcKVjftUr0YT7qQssYbUFE"

export const MOONPAY_API_BASE_URL = "https://api.moonpay.com"

export const MOONPAY_API_CHECK_IP_URL = `${MOONPAY_API_BASE_URL}/v4/ip_address?apiKey=${MOONPAY_CLIENT_API_KEY}`

export const MOONPAY_THEME_ID = "94c3acae-4a54-496b-8d95-15bc4ad62e6e"
